<template>
	<div class="page-wrapper">
		<div class="page page-settings">
			<div class="container">
				<div class="page-header">
					<h1 class="page-title">
						<router-link class="text" to="/settings">Settings</router-link>
						<i class="separator material-icons">chevron_right</i>
						<span class="page-breadcrumb">Connections</span>
					</h1>
				</div>
				<div class="page-content">
					<div class="alert alert-warning" role="alert" v-if="isShowAlert('oo_account')">
						<i class="bi-info-circle-fill"></i> Untuk dapat menambahkan produk ke <b>OrderOnline.id</b> silahkan hubungkan akun anda.
					</div>
					<div class="box p-0">
						<!-- GetResponse -->
						<div class="integration-item">
							<div class="integration-app">
								<div class="wrapper">
									<div class="">
										<img
											src="/images/logo-small-orderonline.jpg"
											alt="OrderOnline"
										/>
									</div>
									<button
										type="button"
										class="integration-app-button btn btn-primary"
										@click="openWindowConnection"
										v-if="orderonlineAccounts.length === 0"
									>
										+ Add OrderOnline Account
									</button>
								</div>
							</div>
							<connection-accounts
								:name="'GetResponse Accounts'"
								:accounts="orderonlineAccounts"
								@remove="removeIntegration"
								:can-remove="!isHasFeature(user, 'official_seller')"
								:user="user"
							>
							</connection-accounts>
						</div>
						<!-- Berduid -->
						<!-- <div class="integration-item">
							<div class="integration-app">
								<div class="wrapper">
									<div class="integration-app-logo">
										<img src="/images/logo-small-berdu.png" alt="Berdu.id" />
									</div>
									<button
										type="button"
										class="integration-app-button btn btn-primary disabled"
									>
										Coming Soon
									</button>
								</div>
							</div>
							<connection-accounts
								:name="'Berdu Accounts'"
								:accounts="berduAccounts"
								@remove="removeIntegration"
							>
							</connection-accounts>
						</div> -->
						<!-- WooCommerce -->
						<!-- <div class="integration-item">
							<div class="integration-app">
								<div class="wrapper">
									<div class="integration-app-logo">
										<img
											src="/images/logo-small-woocommerce.jpg"
											alt="WooCommerce"
										/>
									</div>
									<button
										type="button"
										class="integration-app-button btn btn-primary disabled"
										v-if="wooAccounts.length === 0"
									>
										Coming Soon
									</button>
								</div>
							</div>
							<connection-accounts
								:name="'WooCommerce Accounts'"
								:accounts="wooAccounts"
								@remove="removeIntegration"
							>
							</connection-accounts>
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<div class="modals">
			<!--  -->
		</div>

		<notifications group="autoresponder" position="bottom right" />
	</div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Modal from '../components/Modal.vue';
import {
	getAxiosErrorMessage,
	getOS,
	getDeviceType,
	getBrowser,
	duplicateVar,
	isHasFeature,
} from '@/lib/helper';
import ConnectionAccounts from '../components/ConnectionAccounts.vue';
import userApi from '@/api/user';
import dropshipApi from '@/api/dropship';
import Axios from 'axios';

const base_url = process.env.VUE_APP_BASE_URL || 'https://app.ostock.id';

export default {
	name: 'settingsAutoresponder',
	components: {
		Modal,
		ConnectionAccounts,
	},
	data() {
		return {
			isFetching: false,
			ip: null,
			location: '',
			position: null,
			latitude: 0,
			longitude: 0,
			isLocating: false,
			locationData: null,
			isLocationFetched: true,
			connections: [],
		};
	},
	watch: {
		ip() {
			if (this.ip) {
				const geoApiKey = process.env.VUE_APP_GEODB_API_KEY;
				const endpoint = `https://geolocation-db.com/json/${geoApiKey}/${this.ip}`;
				Axios.get(endpoint)
					.then(({ data }) => {
						this.locationData = data;
						const city = data.city || 'Unknown city';
						const country = data.country_name || 'Unknown country';
						const location = `${city}, ${country}`;
						this.location = location;
						this.isLocationFetched = true;
					})
					.catch(() => {
						this.isLocationFetched = true;
					});
			}
		},
	},
	methods: {
		getIp() {
			const endpoint = 'https://public.orderonline.id/ip';
			Axios.get(endpoint)
				.then(response => {
					const ip = response.data.ip;
					this.ip = ip;
				})
				.catch(() => {
					this.isLocationFetched = true;
				});
		},
		getLocation() {
			this.isLocating = true;
			if (navigator.geolocation) {
				const onSuccess = pos => {
					this.position = duplicateVar(pos);
					const lat = pos.coords.latitude;
					const long = pos.coords.longitude;
					this.latitude = lat;
					this.longitude = long;
					this.isLocating = false;
				};
				const onError = () => {
					this.isLocating = false;
				};
				navigator.geolocation.getCurrentPosition(onSuccess, onError);
			} else {
				this.isLocating = false;
			}
		},
		fetchConnection() {
			const callback = response => {
				this.connections = response.data;
				if (this.isOoLoggedIn && this.$route.query.redirect) {
					this.$router.push(this.$route.query.redirect);
				}
				this.isSubmitting = false;
			};
			const errorCallback = e => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Error data tidak ada',
					text: message,
				});
				this.isSubmitting = false;
			};
			if (!this.isSubmiting) {
				userApi.connectionList(callback, errorCallback);
			}
		},
		removeIntegration(account) {
			this.removeAccount(account._id);

			const callback = response => {
				if (account.source.type === 'orderonline') {
					// localStorage.removeItem('oo_token');
					this.removeOoAccount(account);
				}
			};
			userApi.removeConnection(account._id, callback);
		},
		removeOoAccount(account) {
			const callback = response => {
				if (account.source.type === 'orderonline') {
					localStorage.removeItem('oo_token');
				}
			};
			dropshipApi.removeConnection(account.token, callback);
		},
		removeAccount(id) {
			const index = this.connections.findIndex(account => account._id === id);
			if (index !== -1) {
				this.connections.splice(index, 1);
			}
		},
		openWindowConnection() {
			const token = this.$uuid.v4();
			const user_id = this.user._id;
			const source = JSON.stringify({
				id: user_id,
				type:'ostock',
				name: this.user.name
			});
			const metaJson = JSON.stringify(this.meta);
			this.popupWindow({
				url: `${
					this.ooWeb
				}/connect?callback=${base_url}/connection/callback&token=${token}&source_id=${user_id}&source=${source}&meta=${metaJson}`,
				title: 'xtf',
				w: 900,
				h: 500,
			});
		},
		popupWindow({ url, title, w, h }) {
			// Fixes dual-screen position                             Most browsers      Firefox
			const dualScreenLeft =
				window.screenLeft !== undefined ? window.screenLeft : window.screenX;
			const dualScreenTop =
				window.screenTop !== undefined ? window.screenTop : window.screenY;

			const width = window.innerWidth
				? window.innerWidth
				: document.documentElement.clientWidth
				? document.documentElement.clientWidth
				: screen.width;
			const height = window.innerHeight
				? window.innerHeight
				: document.documentElement.clientHeight
				? document.documentElement.clientHeight
				: screen.height;

			const systemZoom = width / window.screen.availWidth;
			const left = (width - w) / 2 / systemZoom + dualScreenLeft;
			const top = (height - h / 2) / 2 / systemZoom + dualScreenTop;
			const newWindow = window.open(
				url,
				title,
				`
			scrollbars=yes,
			width=${w / systemZoom},
			height=${h / systemZoom},
			top=${top},
			left=${left}
			`,
			);

			if (window.focus) newWindow.focus();
		},
		isShowAlert(type) {
			return !this.isOoLoggedIn && this.$route.query.msg === type;
		},
		isHasFeature,
	},
	computed: {
		...mapGetters({
			ooWeb: 'ooWeb',
			user: 'user',
			isOoLoggedIn: 'isOoLoggedIn',
			isDropshipper: 'isDropshipper',
		}),
		orderonlineAccounts() {
			return this.connections.filter(
				connection => connection.source.type === 'orderonline',
			);
		},
		berduAccounts() {
			return this.connections.filter(
				connection => connection.source === 'berdu.id',
			);
		},
		wooAccounts() {
			return this.connections.filter(
				connection => connection.source === 'woocommerce',
			);
		},
		meta() {
			const os = getOS();
			const deviceType = getDeviceType();
			const browser = getBrowser();
			const location = this.location;
			const userAgent = window.navigator.userAgent;
			const meta = {
				ip: this.ip,
				os,
				device: deviceType,
				browser,
				location,
				lat: this.latitude,
				long: this.longitude,
				user_agent: userAgent,
			};
			return meta;
		},
	},
	watch: {
		'user': {
			handler(newValue) {
				if (Object.keys(newValue).length > 0 && !this.isDropshipper) {
					this.$router.push({ path: '/' });
				}
			},
			deep: true,
			immediate: true,
		},
	},
	created() {
		this.getIp();
		this.getLocation();
		if (!this.isFetching) {
			this.fetchConnection();
		}
	},
};
</script>
